import { useConfigHelper } from '@ilteducation/config';

const { getUrl } = useConfigHelper();

export const createLogoutLink = (redirectUrl: string, idToken?: string) => {
  const url = new URL(`${getUrl('auth')}/logout`);
  url.searchParams.set('post_logout_redirect_uri', redirectUrl);
  if (idToken) {
    url.searchParams.set('id_token_hint', idToken);
  }
  return url.toString();
};
